module.exports = __webpack_public_path__ + "img/background-silver-large.06c4132a.svg";